<template>
  <div class="login">
    <div class="login-container">
      <div class="header">
        <h2>后台管理系统</h2>
      </div>

      <el-row class="login-container-row">

        <el-col :span="24" class="col form">
          <el-input
            v-model="email"
            placeholder="请输入账号">
            <i slot="prefix" class="el-input__icon el-icon-edit"></i>
          </el-input>

          <el-input
            v-model="password"
            type="password"
            placeholder="请输入密码">
            <i slot="prefix" class="el-input__icon el-icon-edit"></i>
          </el-input>

          <div class="login_box">
            <el-button
              @click="recaptcha"
              type="primary"
              round>
              立即登录
            </el-button>
          </div>
        </el-col>
      </el-row>

    </div>
  </div>

</template>

<script>
import { load } from 'recaptcha-v3';
import { setLocalStorage } from '../../utils/utils';

export default {
  name: 'Login',
  data() {
    return {
      email: '',
      password: '',
      googleRecaptchaToken: '',
      googleAnswerToken: '',
    };
  },
  created() {
  },
  methods: {
    async recaptcha() {
      if (this.email === '') {
        this.$message.error('请输入账号');
        return;
      }
      if (this.password === '') {
        this.$message.error('请输入密码');
        return;
      }
      this.login();
      // load('6LesLeUUAAAAABm3Ovs1VCdRPeTH78pTLY9lWGte', {
      //   useRecaptchaNet: true,
      //   autoHideBadge: true,
      // }).then((recaptcha) => {
      //   recaptcha.execute('login').then((token) => {
      //     this.googleRecaptchaToken = token;
      //     this.reCaptchaVerify();
      //   });
      // });
    },
    reCaptchaVerify() {
      const data = {
        GoogleRecaptchaToken: this.googleRecaptchaToken,
      };
      this.$http.post('/v1/platform/reCaptcha/verify', data).then((res) => {
        if (res.Code === this.$requestCode.RESPONSE_SUCCESS.code) {
          this.googleAnswerToken = res.Data.GoogleAnswerToken;
          this.login();
        } else {
          this.$requestStatus(res);
        }
      });
    },
    login() {
      const data = {
        Email: this.email,
        Password: this.password,
        RecaptchaInfo: {
          GoogleRecaptchaToken: this.googleRecaptchaToken,
          GoogleAnswerToken: this.googleAnswerToken,
        },
      };
      this.$http.post('/admin/login', data).then((res) => {
        if (res.Code === this.$requestCode.RESPONSE_SUCCESS.code) {
          setLocalStorage('sessionId', res.Data.SessionId);
          setLocalStorage('userName', this.email);
          this.$bus.$emit('login', this.email);
          history.go(0);
        } else {
          this.$requestStatus(res);
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.login {
  position: fixed;
  width: 100%;
  height: 100%;
  background: #409EFF;
  z-index: 100;
  display: flex;
  justify-content: center;
  align-items: center;
  .login-container {
    width: 30vw;
    height: 30vw;
    min-width: 400px;
    min-height: 300px;
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 2px 12px 0 rgba(0,0,0,.2);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    .header {
      padding-top: 26px;
      height: 55px;
    }
    .login-container-row {
      width: 100%;
      height: 100%;
      .col {
        padding: 16px;
      }
      .form {
        height: 100%;
        padding: 0 60px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        margin: 0 auto;
        .auth_code {
          display: flex;
          align-items: center;
          margin-bottom: 32px;
          .el-input {
            margin: 0;
          }
          .el-button {
            width: 120px;
            height: 40px;
            margin: 0;
          }
        }
        .login_box {
          text-align: center;
          span {
            display: block;
            cursor: pointer;
            font-size: 12px;
            color: #409EFF;
            margin-bottom: 32px;
          }
        }
        .el-input {
          margin-bottom: 32px;
          ::v-deep input.el-input__inner {
            border-top: 0;
            border-left: 0;
            border-right: 0;
            padding-left: 38px;
            border-radius: 0;
          }
          ::v-deep i {
            font-size: 16px;
          }
        }
        ::v-deep button {
          width: 90%;
        }
      }
      img {
        width: 100%;
        height: auto;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/Login.vue